/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Instructs the client to open a URL (e.g. in a popup) to continue a custom auth flow, then resume by calling /custom-auth/connect with the sessionId.
 * @export
 * @interface RedirectResponse
 */
export interface RedirectResponse {
    /**
     * The URL the client should open to continue the flow.
     * @type {string}
     * @memberof RedirectResponse
     */
    url: string;
    /**
     * The flow identifier to pass back to /custom-auth/connect once the provider redirects to the callback.
     * @type {string}
     * @memberof RedirectResponse
     */
    sessionId: string;
}

/**
 * Check if a given object implements the RedirectResponse interface.
 */
export function instanceOfRedirectResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "sessionId" in value;

    return isInstance;
}

export function RedirectResponseFromJSON(json: any): RedirectResponse {
    return RedirectResponseFromJSONTyped(json, false);
}

export function RedirectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedirectResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
        'sessionId': json['sessionId'],
    };
}

export function RedirectResponseToJSON(value?: RedirectResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'sessionId': value.sessionId,
    };
}

